import React from 'react';

const Password = ({ className, style }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className,
    style: { ...style, overflow: "visible" }
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M10.8683 11.625H10.875M7.125 11.625H7.13172",
      stroke: "#BFBFBF",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M3.20086 14.1336C3.36952 15.3862 4.4071 16.3676 5.66974 16.4257C6.73221 16.4745 7.81148 16.5 9 16.5C10.1885 16.5 11.2678 16.4745 12.3303 16.4257C13.5929 16.3676 14.6305 15.3862 14.7991 14.1336C14.9092 13.316 15 12.4782 15 11.625C15 10.7718 14.9092 9.93399 14.7991 9.11644C14.6305 7.86377 13.5929 6.88237 12.3303 6.82432C11.2678 6.77548 10.1885 6.75 9 6.75C7.81148 6.75 6.73221 6.77548 5.66974 6.82432C4.4071 6.88237 3.36952 7.86377 3.20086 9.11644C3.09078 9.93399 3 10.7718 3 11.625C3 12.4782 3.09078 13.316 3.20086 14.1336Z",
      stroke: "#BFBFBF",
      strokeWidth: "1.5"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M5.625 6.75V4.875C5.625 3.01104 7.13604 1.5 9 1.5C10.864 1.5 12.375 3.01104 12.375 4.875V6.75",
      stroke: "#BFBFBF",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);

export { Password };
//# sourceMappingURL=Password.js.map
